import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Menu } from '../../interfaces/interfaces';
import { User } from '../../models/User';
import { environment } from 'src/environments/environment';

// Prefijo de la llave en localStorage para la preferencia "Ocultar módulos duplicados".
// Se guarda por usuario (prefijo + id del usuario) y cleanSession NO la borra, para que
// la preferencia sobreviva a recargas y a cierres de sesión.
const HIDE_DUPLICATED_MENUS_KEY_PREFIX = 'hideDuplicatedMenus_';

@Injectable({
  providedIn: 'root'
})

export class MenuService {

  menu: Menu[] = [
    {
      title: 'INICIO',
      url: '/admin/dashboard',
      icon: 'home',
      rolKey: 'dashboard',
      urlAngularJS: false,
      model: 'inicio',
      migratedUrl: '/admin/inicio-2'
    },
    {
      title: 'INICIO',
      url: '/admin/inicio-2',
      icon: 'home',
      rolKey: 'dashboard',
      urlAngularJS: false,
      model: 'inicio'
    },
    // {
    //   title: 'DASHBOARD',
    //   url: '/admin/geocerca-vnext-test-2',
    //   icon: 'dashboard',
    //   rolKey: 'dashboard',
    //   urlAngularJS: false
    // },
    {
      title: 'GEOLOCALIZACIÓN',
      url: '/admin/geocerca-vnext-test',
      icon: 'dashboard',
      rolKey: 'dashboardgeolocation.view',
      urlAngularJS: false
    },
    {
      title: 'MINUTAS',
      url: '/admin/minutas',
      icon: 'find_in_page',
      rolKey: 'memorandums.view',
      urlAngularJS: false,
      model: 'minutas',
      migratedUrl: '/admin/minutas-2'
    },
    {
      title: 'MINUTAS',
      url: '/admin/minutas-2',
      icon: 'find_in_page',
      rolKey: 'memorandums.view',
      urlAngularJS: false,
      model: 'minutas'
    },
    // Administrador Angular 9 (legacy): se reemplaza por Administrador 2 (Angular 21)
    // abajo. Se oculta cuando el usuario activa "Ocultar módulos duplicados".
   {
       title: 'ADMINISTRADOR',
       url: '/admin/companies',
       icon: 'account_balance',
       rolKey: 'companies.view',
       urlAngularJS: false,
       model: 'administradora',
       migratedUrl: '/admin/administrador-2'
     },
    {
      title: 'ADMINISTRADOR',
      url: '/admin/administrador-2',
      icon: 'account_balance',
      rolKey: 'companies.view',
      urlAngularJS: false,
      model: 'administradora'
    },
    {
      title: 'EMPRESAS',
      url: '/admin/employers',
      icon: 'business',
      rolKey: 'employers.view',
      urlAngularJS: false,
      model: 'employer',
      migratedUrl: '/admin/employers-2'
    },
    {
      title: 'EMPRESAS',
      url: '/admin/employers-2',
      icon: 'business',
      rolKey: 'employers.view',
      urlAngularJS: false,
      model: 'employer',
      toggleSubMenu: false,
      withSubMenu: true,
      navigateOnToggle: true,
      subMenu: [{title: 'Seguridad social', url: '/admin/social-security-2'}]
    },
    {
      title: 'PROYECTOS',
      url: '/admin/project',
      icon: 'location_city',
      rolKey: 'projects.view',
      urlAngularJS: false,
      model: 'project',
      migratedUrl: '/admin/projects-2'
    },
    {
      title: 'PROYECTOS',
      url: '/admin/projects-2',
      icon: 'location_city',
      rolKey: 'projects.view',
      urlAngularJS: false,
      model: 'project'
    },
    {
      title: 'CARNETS',
      url: '/admin/carnets',
      icon: 'badge',
      rolKey: 'carnets.view',
      urlAngularJS: false
    },
    {
      title: 'CONTRATOS',
      url: '/admin/contract',
      icon: 'gavel',
      rolKey: 'contracts.view',
      urlAngularJS: false,
      model: 'contract'
    },
    {
      title: 'PERSONAL',
      url: '/admin/personal',
      icon: 'person',
      rolKey: 'personals.view',
      urlAngularJS: false,
      model: 'personal'
    },
    {
      title: 'INGRESOS',
      url: '/admin/request',
      icon: 'how_to_reg',
      customIcon: 'assets/images/Entrada.png',
      rolKey: 'contractstages.view',
      urlAngularJS: false,
      model: 'ingresos'
    },
    {
      title: 'RETIROS',
      url: '/admin/termination',
      icon: 'person_remove',
      customIcon: 'assets/images/Salida.png',
      rolKey: 'personaltermination.view',
      urlAngularJS: false,
      model: 'termination'
    },
    {
      title: 'CONTRATOS INDIVIDUALES',
      url: '/admin/contracting',
      icon: 'folder_shared',
      rolKey: 'contracting.view',
      urlAngularJS: false
    },
    {
      title: 'VEHICULOS',
      url: '/admin/vehicle',
      icon: 'time_to_leave',
      rolKey: 'vehicles.view',
      urlAngularJS: false,
      migratedUrl: '/admin/vehicles-2'
    },
    {
      title: 'VEHICULOS',
      url: '/admin/vehicles-2',
      icon: 'time_to_leave',
      rolKey: 'vehicles.view',
      urlAngularJS: false
    },
    {
      title: 'USUARIOS',
      url: '/admin/profile',
      icon: 'account_circle',
      rolKey: 'users.view',
      urlAngularJS: false,
      model: 'profile',
      migratedUrl: '/admin/users-2'
    },
    {
      title: 'USUARIOS',
      url: '/admin/users-2',
      icon: 'account_circle',
      rolKey: 'users.view',
      urlAngularJS: false,
      model: 'profile'
    },
    {
      title: 'INFORMES',
      url: '/admin/info',
      icon: 'text_snippet',
      rolKey: 'informs.view',
      urlAngularJS: false
    },
    {
      title: 'REFERENCIAS',
      url: '/admin/references',
      icon: 'border_all',
      rolKey: 'superuser',
      urlAngularJS: false,
      toggleSubMenu: false,
      withSubMenu: true,
      subMenu: [{title: 'Opciones comunes', url: '/admin/references/commonOptions-list'},
                {title: 'Requisitos de acceso', url: '/admin/references/requirement-list'},
                {title: 'Imagenes de formularios', url: '/admin/references/form-image-list'},
                {title: 'Administradoras Sistema de Seguridad Social y Parafiscales', url: '/admin/references/security-reference-list'},
                {title: 'Actividades Económicas', url: '/admin/references/economicActivity-list'},
                {title: 'Ocupaciones', url: '/admin/references/occupation-list'},
                {title: 'Insumos', url: 'null'},
                {title: 'Grupos insumos', url: '/admin/references/supplyGroup'},
                {title: 'Listas insumos', url: '/admin/references/supplyList'},
                {title: 'Rango de fechas para pago de seguridad social', url: '/admin/references/social-sec-range-list'},
                {title: 'Idiomas y Colores', url: '/admin/references/language-color-list'},
              ]
    },
    {
      title: 'ADMINISTRACÓN',
      url: '/admin/management',
      icon: 'build',
      rolKey: 'superuser',
      urlAngularJS: false,
      toggleSubMenu: false,
      withSubMenu: true,
      subMenu: [{title: 'Perfiles', url: '/admin/management/perfil'},
      ]
    },
  ];

  // Emite cada vez que el usuario cambia la preferencia "Ocultar módulos duplicados",
  // para que el menú lateral se recalcule al instante (sin recargar la página).
  hideDuplicatedMenusChange = new Subject<boolean>();

  constructor() {
    // "Mi perfil" migrado (widget <geo-dashboard>, vista profile) guarda la misma
    // preferencia en localStorage y avisa con este evento para recalcular el menú.
    window.addEventListener('geo-hide-duplicated-menus-change', (event: Event) => {
      this.hideDuplicatedMenusChange.next((event as CustomEvent<boolean>).detail === true);
    });
  }

  // Llave de localStorage del usuario logueado (null si no hay sesión).
  private getHideDuplicatedMenusKey(): string | null {
    let user: User = null;
    try {
      user = JSON.parse(localStorage.getItem('user')) as User;
    } catch (e) {
      user = null;
    }
    const userKey = user?.sub || user?.Email || user?.username;
    return userKey ? HIDE_DUPLICATED_MENUS_KEY_PREFIX + userKey : null;
  }

  // La opción "Ocultar módulos duplicados" es solo para pruebas: existe únicamente en
  // QAS (environment.production === false). En producción no se muestra ni se aplica,
  // aunque el navegador tenga guardada la preferencia de una sesión de QAS.
  isDuplicatedMenusOptionAvailable(): boolean {
    return environment.production === false;
  }

  // Se lee siempre de localStorage (no se cachea) para respetar el usuario actual.
  isHideDuplicatedMenus(): boolean {
    if (!this.isDuplicatedMenusOptionAvailable()) { return false; }
    const key = this.getHideDuplicatedMenusKey();
    return key !== null && localStorage.getItem(key) === 'true';
  }

  setHideDuplicatedMenus(value: boolean): void {
    const key = this.getHideDuplicatedMenusKey();
    if (key === null) { return; }
    if (value) {
      localStorage.setItem(key, 'true');
    } else {
      localStorage.removeItem(key);
    }
    this.hideDuplicatedMenusChange.next(value);
  }

  // Nombre del módulo (según el menú) al que pertenece la url, para el título de la
  // pestaña del navegador. Gana la url de menú/submenú más larga que coincida por
  // segmentos completos ('/admin/project' NO coincide con '/admin/projects-2').
  getModuleTitleByUrl(url: string): string | null {
    const path = String(url || '').split(/[?#;]/)[0];
    const entries: { url: string; title: string }[] = [];
    for (const item of this.menu) {
      entries.push({ url: String(item.url || ''), title: String(item.title || '') });
      for (const sub of item.subMenu || []) {
        entries.push({ url: String(sub.url || ''), title: String(sub.title || '') });
      }
    }
    let bestUrl = '';
    let bestTitle: string | null = null;
    for (const entry of entries) {
      if (!entry.url || entry.url === 'null' || !entry.title) { continue; }
      const matches = path === entry.url || path.startsWith(entry.url + '/');
      if (matches && entry.url.length > bestUrl.length) {
        bestUrl = entry.url;
        bestTitle = entry.title;
      }
    }
    return bestTitle;
  }

  // Recibe el menú YA filtrado por permisos. Si la preferencia está activa, quita las
  // entradas legacy cuya versión migrada (migratedUrl) también está en la lista; si el
  // usuario no ve la migrada, la legacy se conserva para no dejarlo sin el módulo.
  filterDuplicatedMenus(items: Menu[]): Menu[] {
    if (!this.isHideDuplicatedMenus()) { return items; }
    const urls = items.map(item => item.url);
    return items.filter(item => !item.migratedUrl || !urls.includes(item.migratedUrl));
  }

}
